import {ApiResponse, dataKey, Entry, scrollKey} from "./model";

class NewsfeedService {
    private totalNewsCount = 0;
    private readonly langId: number;

    constructor() {
        this.langId = location.href.includes('/en/') ? 1 : 0;
    }

    getPath(entry: Entry) {
        if(this.langId == 1) {
            return `/en/newsfeed-en/detail/id-${entry.uid}`;
        }
        return `/newsfeed/detail/id-${entry.uid}`;
    }

    async loadNews() {
        const newsOffset = document.querySelectorAll(".newsfeed .item").length;
        const news = await this.fetchData(`/api/stories/news/${newsOffset}/${this.langId}`);

        this.totalNewsCount = news.count;
        this.appendNews(news.items);

        if (sessionStorage.getItem(dataKey)) {
            const sessionItems: Entry[] = JSON.parse(sessionStorage.getItem(dataKey));
            sessionItems.push(...news.items);
            sessionStorage.setItem(dataKey, JSON.stringify(sessionItems))
        } else {
            sessionStorage.setItem(dataKey, JSON.stringify(news.items))
        }
    }

    async loadStories() {
        let storyOffset = document.querySelectorAll(".stories .story-wrapper").length;
        const stories = await this.fetchData(`/api/stories/story/${storyOffset}/${this.langId}`);

        this.appendStories(stories.items);

        if (stories.count == 0) {
            const storyContainer = document.querySelector(".employee-stories");

            if (storyContainer) {
                storyContainer.remove();
            }
        }
    }

    appendNews(items: Entry[]) {
        const newsContainer = document.querySelector(".newsfeed");

        for (const news of items) {
            const media = news.images[0];
            let preview = ``;

            if (media.publicUrl.includes("youtube.com/watch")) {
                const videoId = new URL(media.publicUrl).searchParams.get("v")

                preview = `
                    <cookie-overlay cookie="NY_COOKIE_YOUTUBE" placeholder="https://img.youtube.com/vi/${videoId}/maxresdefault.jpg">
                        <template>
                            <iframe src="https://www.youtube-nocookie.com/embed/${videoId}?autohide=1&controls=1&enablejsapi=1&origin=${location.origin}" allowfullscreen allow="fullscreen"></iframe>
                        </template>
                    </cookie-overlay>
                `;
            } else if (media.publicUrl.endsWith(".mp4") || media.publicUrl.endsWith(".webm")) {
                preview = `
                    <video controls>
                        <source src="/${media.publicUrl}" type="video/${media.publicUrl.split(".").pop()}">
                    </video>
                `;
            } else {
                preview = `<img src="/${media.publicUrl}" alt=""/>`;
            }

            const entry = `
                <div class="item" id="item-id-${news.uid}">
                    <a class="link" href="${this.getPath(news)}" id="show-item-id-${news.uid}">
                        <span class="title">${news.title}</span>
                    </a>
                    
                    <div class="image">
                        ${preview}
                
                        ${news.images.length > 1 ? `<div class="more-wrapper">
                            <a class="link" href="${this.getPath(news)}">
                                <div class="more">
                                    <span>+</span>
                                    <span>${news.images.length - 1}</span>
                                </div>
                            </a>
                        </div>` : ""}
                    </div>
                    
                    <a class="caption-link" href="${this.getPath(news)}">
                        <div class="caption">${this.removeLinks(news.text)}</div>
                    </a>
                </div>
            `;

            newsContainer.insertAdjacentHTML("beforeend", entry);
        }

        if (this.totalNewsCount === newsContainer.querySelectorAll(".item").length) {
            const button = document.querySelector(".button-more-stories-wrapper .button-more-stories");
            button.classList.add("disabled")
        }

        newsContainer.querySelectorAll(".placeholder").forEach(placeholder => {
            placeholder.remove();
        });
    }

    private appendStories(items: Entry[]) {
        const storyContainer = document.querySelector(".stories");

        for (const story of items) {
            const entry = `
                <a class="story-wrapper" href="${this.getPath(story)}">
                    <div class="story">
                        <img src="/${story.images[0].publicUrl}" alt=""/>
              
                        <div class="details">
                            <span class="name">${story.title}</span>
                            <span class="text">${story.text}</span>
                        </div>
                    </div>
                </a>
            `;

            storyContainer.insertAdjacentHTML("beforeend", entry);
        }
    }

    private async fetchData(path: string): Promise<ApiResponse> {
        const res = await fetch(path, {
            method: "GET",
            redirect: "follow"
        });

        if (!res.ok) {
            throw new Error(`failed to load data`);
        }

        return await res.json();
    }

    private removeLinks(text: string) {
        const container = document.createElement("div");
        container.innerHTML = text;

        const links = container.querySelectorAll("a");
        links.forEach(link => {
            let innerHtml = link.innerHTML;
            let textNode = document.createTextNode(innerHtml);
            link.replaceWith(textNode);
        })

        return container.innerHTML;
    }

    clearSession() {
        sessionStorage.removeItem(scrollKey);
        sessionStorage.removeItem(dataKey);
    }
}

export const newsfeedService = new NewsfeedService();
